module.exports = __webpack_public_path__ + "portal-static/img/10.7aa11944.jpg";